export const IMAGEKIT_ID = 'ymjlyrr8zyb';
export const IMAGEKIT_ENDPOINT = 'https://ik.imagekit.io/ymjlyrr8zyb';
export const IMAGEKIT_PUBLIC_KEY = 'public_aEaOaYimggRM+4kgwtcDb4PKl9Y=';

// export const IMAGEKIT_ID = 'iadva4w6splb';
// export const IMAGEKIT_ENDPOINT = 'https://ik.imagekit.io/iadva4w6splb';
// export const IMAGEKIT_PUBLIC_KEY = 'public_BnGmzngTpoElcIXeAOsPad7vRW4=';
